import request from './request'

const authHeader = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` })

export function listTasks(params = {}) {
  return request({ url: '/tasks', method: 'get', params, headers: authHeader() })
}
export function getTask(id) {
  return request({ url: `/tasks/${id}`, method: 'get', headers: authHeader() })
}
export function retryTask(id) {
  return request({ url: `/tasks/${id}/retry`, method: 'post', headers: authHeader() })
}
export function cancelTask(id) {
  return request({ url: `/tasks/${id}/cancel`, method: 'post', headers: authHeader() })
}
export function deleteTask(id) {
  return request({ url: `/tasks/${id}`, method: 'delete', headers: authHeader() })
}
